import React from "react";
import { NavLink } from "react-router-dom";




const Sidebar = ({ isOpen, closeSidebar }) => {
  const role = sessionStorage.getItem("role");

  return (
    <aside className={`sidebar ${isOpen ? "open" : ""}`}>

      <ul className="nav flex-column gap-2 p-3">

        {/* QC USER */}
        {role === "QC" && (
          <>
            <NavItem to="/quality-inbound" label="Quality Inbound" closeSidebar={closeSidebar}/>
            <NavItem to="/final-quality" label="Quality Outbound" closeSidebar={closeSidebar}/>
          </>
        )}

        {/* NON QC USERS */}
        {role !== "QC" && (
          <>
            <NavItem to="/dashboard" label="Dashboard" closeSidebar={closeSidebar}/>
            <NavItem to="/order-processing" label="Inbound Operation" closeSidebar={closeSidebar}/>
            <NavItem to="/delivery-order" label="Outbound Operation" closeSidebar={closeSidebar}/>
            <NavItem to="/paste-control" label="Pest Control" closeSidebar={closeSidebar}/>
            <NavItem to="/labour" label="Labour" closeSidebar={closeSidebar}/>
            <NavItem to="/accounts/billing" label="Billing" closeSidebar={closeSidebar}/>
            <NavItem to="/report-billing" label="Report" closeSidebar={closeSidebar}/>
            <NavItem to="/cdd-list" label="CDD List" closeSidebar={closeSidebar}/>
            <NavItem to="/crd-list" label="CRD List" closeSidebar={closeSidebar}/>
          </>
        )}

      </ul>
    </aside>
  );
};

/* Reusable Nav Item */
const NavItem = ({ to, label, closeSidebar }) => (
  <li className="nav-item">
    <NavLink
      to={to}
      onClick={closeSidebar}
      className={({ isActive }) =>
        `nav-link sidebar-link ${isActive ? "active" : ""}`
      }
    >
      {label}
    </NavLink>
  </li>
);

export default Sidebar;
